import React, { useEffect } from 'react';
import Wishlist from './Wishlist';
import { LoadingMoreSpinner } from '../../product-listing-page/components/SmallUIComponents';
import ProminentMessage from '../../page/components/ProminentMessage';
import { wishlistState } from '../../_shared/wishlist/wishlistState';
import { observer } from 'mobx-react-lite';

let WishlistContainer = () => {
  useEffect(() => {
    wishlistState.populateFullData();
    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      // Handle back/forward cache for some browsers
      if (event.persisted) {
        wishlistState.clearState();
        wishlistState.populateFullData();
      }
    });
  }, []);

  if (wishlistState.error) {
    return (
      <ProminentMessage
        subtitle="Unable to Load Wishlist"
        callToAction={{ text: 'Continue Shopping', behavior: { href: '/collections/new-arrivals' } }}
      />
    );
  }

  if (wishlistState.data === null) {
    return <LoadingMoreSpinner />;
  }

  if (wishlistState.data.length === 0) {
    return (
      <ProminentMessage
        icon={() => {
          return (
            <img
              src="https://cdn.shopify.com/s/files/1/2185/2813/files/heart-x2.png?v=1664302399"
              alt="Wishlist"
              width={30}
              height={30}
            />
          );
        }}
        title="Wishlist"
        subtitle="Collect all of your favorite items by clicking on the heart while you shop."
        callToAction={{ text: 'Start Shopping', behavior: { href: '/collections/new-arrivals' } }}
        heapTrackEvents={{
          heapEventName: 'Web - Wishlist - Click Start Shopping',
          heapEventProperties: { isSignedIn: true, 'Wishlist Count': 0 },
        }}
      />
    );
  }

  return (
    <>
      <div id="PLPContainer">
        <div className="container-fluid fw-grid__wrapper content-wrapper" style={{ maxWidth: '1400px' }}>
          <div className="plp-header nativeapp-hide">
            <h1 className="wishlist-header h2">Wishlist</h1>
          </div>
          <div className="main-content">
            <Wishlist wishlistData={wishlistState.data}></Wishlist>
          </div>
        </div>
      </div>
    </>
  );
};

WishlistContainer = observer(WishlistContainer);
export default WishlistContainer;
